var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-scroll-area",
        { staticStyle: { width: "100%", height: "calc(100vh - 106px)" } },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-table", {
                  attrs: {
                    title: "",
                    data: _vm.dataTable,
                    columns: _vm.columns,
                    "row-key": "_OID",
                    pagination: _vm.pagination,
                    "rows-per-page-options": [5, 10, 15, 20, 50, 100, 0],
                    dense: "",
                    separator: "cell",
                    "no-data-label": "brak danych",
                    "no-results-label": "brak wyników",
                    "loading-label": "ładuję dane...",
                    "rows-per-page-label": "rekordów na stronę",
                    "selected-rows-label": function(rowsNumber) {
                      return "zaznaczono " + rowsNumber + " pozycji"
                    },
                    "pagination-label": function(start, end, total) {
                      return start + "-" + end + " z " + total
                    }
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "top-left",
                        fn: function(props) {
                          return [
                            _c("q-btn", {
                              attrs: {
                                color: "primary",
                                label: "Odśwież dane"
                              },
                              on: { click: _vm.fetchData }
                            })
                          ]
                        }
                      },
                      {
                        key: "body-cell-free",
                        fn: function(props) {
                          return _vm.sid === "12" && _vm.dataTable
                            ? _c("q-td", { attrs: { props: props } }, [
                                _vm._v(
                                  "\n             " +
                                    _vm._s(_vm.humanStorageSize(props.value)) +
                                    "\n           "
                                )
                              ])
                            : _vm._e()
                        }
                      },
                      {
                        key: "body-cell-total",
                        fn: function(props) {
                          return _vm.sid === "12" && _vm.dataTable
                            ? _c("q-td", { attrs: { props: props } }, [
                                _vm._v(
                                  "\n             " +
                                    _vm._s(_vm.humanStorageSize(props.value)) +
                                    "\n           "
                                )
                              ])
                            : _vm._e()
                        }
                      },
                      {
                        key: "body-cell-actions",
                        fn: function(props) {
                          return _vm.dataTable
                            ? _c(
                                "q-td",
                                { attrs: { props: props } },
                                _vm._l(props.col.actions, function(item) {
                                  return _c("q-btn", {
                                    key: item.action,
                                    attrs: { size: "sm", label: item.label },
                                    on: {
                                      click: function($event) {
                                        return _vm.actionClick(item, props)
                                      }
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-4" },
              _vm._l(_vm.dataItems, function(item) {
                return _c(
                  "div",
                  { key: item.meid },
                  [
                    _c(
                      "q-list",
                      {
                        attrs: {
                          link: "",
                          separator: "",
                          multiline: "",
                          dense: "",
                          "no-border": ""
                        }
                      },
                      [
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("meid")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.meid))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("cid")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.cid))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("name")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.name))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("fieldname")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.fieldname))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("oid")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.oid))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("value")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.value))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("uid")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.uid))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "col-4" },
              _vm._l(_vm.dataItems, function(item) {
                return _c(
                  "div",
                  { key: item.meid },
                  [
                    _c(
                      "q-list",
                      {
                        attrs: {
                          link: "",
                          separator: "",
                          multiline: "",
                          dense: "",
                          "no-border": ""
                        }
                      },
                      [
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("isparallel")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.isparallel))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("isqueued")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.isqueued))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("pid")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.pid))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("priority")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.priority))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("status")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.status))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "col-4" },
              _vm._l(_vm.dataItems, function(item) {
                return _c(
                  "div",
                  { key: item.meid },
                  [
                    _c(
                      "q-list",
                      {
                        attrs: {
                          link: "",
                          separator: "",
                          multiline: "",
                          dense: "",
                          "no-border": ""
                        }
                      },
                      [
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("eventtime")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [
                                    _c("pre", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date2str")(item.eventtime)
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("eventtime_deleted")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [
                                    _c("pre", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date2str")(
                                            item.eventtime_deleted
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("eventtime_done")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [
                                    _c("pre", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date2str")(
                                            item.eventtime_done
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("eventtime_ready")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [
                                    _c("pre", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date2str")(
                                            item.eventtime_ready
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("eventtime_working")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [
                                    _c("pre", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date2str")(
                                            item.eventtime_working
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              _vm._l(_vm.dataItems, function(item) {
                return _c(
                  "div",
                  { key: item.meid },
                  [
                    _c(
                      "q-list",
                      {
                        attrs: {
                          link: "",
                          separator: "",
                          multiline: "",
                          dense: "",
                          "no-border": ""
                        }
                      },
                      [
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("output")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_c("pre", [_vm._v(_vm._s(item.output))])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v("result")
                                ]),
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-indigo-9",
                                    attrs: { sublabel: "" }
                                  },
                                  [_vm._v(_vm._s(item.result))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _vm.sid === "12" && _vm.dataTable && _vm.charts
            ? _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.charts, function(item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "col-4" },
                    [
                      _c("chart", {
                        attrs: { "auto-resize": "", options: item }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }